export default __webpack_public_path__ + "static/media/hoveredCheckbox.c45a8f29.svg";